export type DemoRoute =
  | "merge"
  | "semantic-ast"
  | "tct-delivery"
  | "guided-story";

export function resolveDemoRoute(search: string): DemoRoute {
  const requested = new URLSearchParams(search).get("demo");
  if (
    requested === "semantic-ast" ||
    requested === "tct-delivery" ||
    requested === "guided-story"
  ) {
    return requested;
  }
  return "merge";
}
